import { render, staticRenderFns } from "./ManagerSimpleCard.vue?vue&type=template&id=416206f6"
import script from "./ManagerSimpleCard.vue?vue&type=script&lang=ts"
export * from "./ManagerSimpleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416206f6')) {
      api.createRecord('416206f6', component.options)
    } else {
      api.reload('416206f6', component.options)
    }
    module.hot.accept("./ManagerSimpleCard.vue?vue&type=template&id=416206f6", function () {
      api.rerender('416206f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ManagerSimpleCard.vue"
export default component.exports